export default {
    companiesList: [],
    numberOfResults: 1,
    departments: [],
}